import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { NAMESPACES, resources, type Translation } from '@il-colpo/shared/locales';
import type { Language } from '@il-colpo/shared/settings';

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'common';
    resources: Translation;
  }
}

/** Initialises i18next synchronously with the bundled resources. Safe to call more than once. */
export function initI18n(language: Language): typeof i18next {
  if (!i18next.isInitialized) {
    void i18next.use(initReactI18next).init({
      lng: language,
      fallbackLng: 'en',
      resources,
      ns: [...NAMESPACES],
      defaultNS: 'common',
      interpolation: { escapeValue: false },
      initAsync: false,
      returnNull: false,
    });
  } else if (i18next.language !== language) {
    void i18next.changeLanguage(language);
  }
  return i18next;
}

export { i18next };
